import { memo, useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { SerializedEditorState, SerializedLexicalNode } from 'lexical';
import isEqual from 'lodash/isEqual';

interface UpdateStatePluginProps {
  state: SerializedEditorState<SerializedLexicalNode>;
}

const arePropsEqual = (
  oldProps: Record<string, unknown>,
  newProps: Record<string, unknown>,
) => isEqual(oldProps, newProps);

export const UpdateStatePlugin = memo(({ state }: UpdateStatePluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (state) {
      const editorState = editor.parseEditorState(state);

      editorState.read(() => {
        editor.setEditorState(editorState);
      });
    }
  }, [editor, state]);

  return null;
}, arePropsEqual);
